import $ from 'jquery';
import isViewport from '../../scripts/util/window/isViewport';
import {tablet} from '../../scripts/util/window/isViewport';
import isIE from '../../scripts/util/detect/detectIE';


const selectors = {
	el: '.js-main-page',
	row: '.news-list__row',
	tiles: {
		middle: '.news-list__item_type_middle',
		small: '.news-list__item_type_small',
		subscribe: '.news-list__item_type_subscribe'
	}
};

const classes = {
	ie: 'ie'
};

const $el = $(selectors.el);
const $window = $(window);

const addClassIE = () => {
	const $page = $('.page');
	if (isIE()) {
		$page.addClass(classes.ie);
	}
};

const setHeight = () => {
	const $row = $el.find(selectors.row);
	const $smallTile = $el.find(selectors.tiles.small);
	const height = $smallTile.outerHeight(true) * 2 + 10;

	$row.height(height);
};

const onLoad = () => {
	if (!isViewport(tablet)) {
		setHeight();
	}
};

const onResize = () => {
	const $row = $el.find(selectors.row);
	if (!isViewport(tablet)) {
		setHeight();
	} else {
		$row.removeAttr('style');
	}
};

const render = () => {
	if ($el.length && isIE()) {
		$window.on('load', onLoad);
		$window.on('resize', onResize);
	}
};

export default render;
export {addClassIE};



/** WEBPACK FOOTER **
 ** ./app/blocks/main/index.js
 **/